<template>
    <div v-show="isVisible" class="mb-5rem">
        <h3 class="learnworlds-heading3 learnworlds-element learnworlds-heading3-normal">
            {{ i18n.get('payments.billing_details_title') }}
        </h3>
        
        <div v-if="paymentAdditionalTitle.length"
             class="learnworlds-overline-text learnworlds-element no-margin-bottom">
            {{ paymentAdditionalTitle }}
        </div>
        
        <textarea
                :class="{'lw-brand-border': errors.first('additionalInfo') }"
                name="additionalInfo"
                v-model="additionalInfo"
                v-validate="(paymentAdditionalRequired) ? 'required' : ''"
                data-vv-as="Extra Data"
                :placeholder="i18n.get('payments.invoice_details_placeholder')"
                class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal learnworlds-element"
                style="height: 150px; resize: none;"></textarea>

        <p v-if="paymentAdditionalLabel.length" class="learnworlds-main-text-normal">
            {{ paymentAdditionalLabel }}
        </p>

        <span class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
            {{ errors.first('additionalInfo') }}
        </span>
    </div>
</template>
<script>
    import {mapGetters, mapState} from 'vuex';
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";

    export default {
        name: "PaymentBillingInfo",
        
        mixins: [],
        
        data() {
            return {
                componentType: "PaymentBillingInfo",
                rendersWithVue: true,
                additionalInfo: "",
                validationChecked: false,
                show: true,
            }
        },
        
        computed: {
            ...mapState([
                'paymentHasAdditional',
                'paymentAdditionalRequired',
                'paymentAdditionalTitle',
                'paymentAdditionalLabel'
            ]),
            
            contextWrapper() {
                return this.hasContext("payment-manager") 
                    ? this.findNodeState(this.hasContext("payment-manager")[0].id) 
                    : null;
            },
            
            getDefaultDataStructure() {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    styles: null,              
                    visibilityStatus: true,
                    itemVisibilitySettings: null
                }
            },
            
            isVisible() {
                return this.getVisibilityStatus &&
                    this.show &&
                    this.paymentHasAdditional;
            },

            getVisibilityStatus() {
                return this.myData.visibilityStatus;
            }
        },
        methods: {
            validate() {
                return new Promise((resolve, reject) => {
                    if(!this.getVisibilityStatus){
                        console.log('Billing Info component validated');
                        return resolve();
                    }
                    this.$validator.validateAll().then(result => {
                        if (!result) {
                            console.log('Billing Info component rejected');
                            return reject();
                        }
                        console.log('Billing Info component validated');
                        return resolve();
                    });
                })
            },
            
            getBillingInfo() {
                return this.additionalInfo;
            },
            
            setAdditionalInfo(info) {
                this.additionalInfo = info;
            },
            
            setVisibility(val) {
                this.show = val;
            }
        }
    }
</script>

